export default {
  name: "ShareSVG",
  props: {
    fill: {
      type: String,
      default: "#FFA621"
    }
  }
};